import { type SerializableRecord } from '@post-office/serializable-record';
import { type TransformMetadataResult } from '@post-office/universal-contracts/message-template-metadata';
import { defaultTransformMetadata } from '../../../stages/placement-message/backend/transform-metadata/default';
import { type BackendSyncMessageStage, type AnyPayload } from '../../types';

export const defaultMessageBackend = (): {
	transformMetadata: {
		validate: (input: unknown) => SerializableRecord;
		stage: BackendSyncMessageStage<SerializableRecord, TransformMetadataResult>;
	};
} => ({
	transformMetadata: {
		validate: noValidation(),
		stage: defaultTransformMetadata,
	},
});

export const noValidation =
	<T = AnyPayload>(_valueWithType?: T): ((input: unknown) => T) =>
	(input: unknown) =>
		input as T;
